/** Context that provides divisions visibility (which divisions are ONLINE) */
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./config";

const DEFAULT = {
  irrigazione: true, "trattamento-acqua": true, automazioni: true,
  elettrico: true, fotovoltaico: false, antiincendio: false,
};

const Ctx = createContext({ visibility: DEFAULT, loading: true, refresh: () => {} });

export function DivisionsVisibilityProvider({ children }) {
  const [visibility, setVisibility] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/divisions/settings");
      setVisibility({ ...DEFAULT, ...r.data });
    } catch {
      /* keep defaults on error */
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ visibility, loading, refresh }}>{children}</Ctx.Provider>;
}

export const useDivisionsVisibility = () => useContext(Ctx);
export const isDivisionOnline = (visibility, key) => visibility[key] !== false;
